import React from 'react';
import { textTruncate } from '../../utils/functions';
import errorCover from '../images/errorCover.jpg';

const ItemCard = (props) => {
  const {
    baseCSS = false, item: {
      image = '', title = '', slug = '',
    }, showLearnMore = false,
  } = props;

  const handleImageError = (event) => {
    if (event?.currentTarget && event.currentTarget.src !== errorCover) {
      event.currentTarget.src = errorCover;
    }
  };
  return (
    <div className={!baseCSS ? 'carousel-item' : undefined}>
      <img className="carousel-image" src={image || errorCover} alt="carousel quest" onError={handleImageError} />
      <div className="carousel-title">{textTruncate(title, 80) || ''}</div>
      <div className="carousel-border" />
      {showLearnMore && <a href={`/quests/${slug}`} ><div className="carousel-click-through">Learn More</div> </a>}
    </div>
  );
};

export default ItemCard;
